<button [hidden]="!currentUser" [ngClass]="likeable.likes.liked_by_current_user ? 'community-feed-item__button community-feed-item__button--liked' : 'community-feed-item__button community-feed-item__like-button'" (click)="toggleLike()" [attr.aria-label]="likeable.likes.liked_by_current_user ? 'remove like' : 'like'" [attr.aria-pressed]="likeable.likes.liked_by_current_user">
  @if (likeable.likes.liked_by_current_user) {
    <i class="material-icons" aria-hidden="true">favorite</i>
  }
  @if (!likeable.likes.liked_by_current_user) {
    <i class="material-icons" aria-hidden="true">favorite_border</i>
  }
  @if (showLiked) {
  &ngsp;<span class="community-feed-item-footer__text">{{likeable.likes.liked_by_current_user ? 'Liked' : 'Like'}}</span>
}
</button>
